import type { AdminApiAiUsagePeriod } from "@repo/app-types/entities/aiCreditUsage";
import { DateTime } from "luxon";

/** Usage figures are fractional in the API; whole units everywhere on screen. */
export function formatWholeNumber(value: number): string {
  return Math.round(value).toLocaleString("en-US");
}

/**
 * A usage figure against its allowance — "1,200 of 5,000 credits used", or
 * "1,200 credits used" when no allowance is set.
 */
export function formatUsageAgainstIncluded(
  used: number,
  included: number | null,
  verb: string,
): string {
  return included === null
    ? `${formatWholeNumber(used)} ${verb}`
    : `${formatWholeNumber(used)} of ${formatWholeNumber(included)} ${verb}`;
}

/**
 * A period as "Jul 13 – Aug 12, 2026". `ends_at` is exclusive, so the shown
 * end date is the day before it.
 */
export function formatPeriodLabel(period: AdminApiAiUsagePeriod): string {
  const start = DateTime.fromISO(period.starts_at, { zone: "utc" });
  const endInclusive = DateTime.fromISO(period.ends_at, { zone: "utc" }).minus({
    days: 1,
  });
  return `${start.toFormat("MMM d")} – ${endInclusive.toFormat("MMM d, yyyy")}`;
}

/** The day the period's allowance resets, i.e. its exclusive `ends_at`. */
export function formatPeriodResetDate(period: AdminApiAiUsagePeriod): string {
  return DateTime.fromISO(period.ends_at, { zone: "utc" }).toFormat("MMM d");
}
